var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('canvas',{staticClass:"circle-item",staticStyle:{"width":"100%"},attrs:{"id":"circle","width":"720px","height":"720px"}})])}]

export { render, staticRenderFns }